import React, { memo, useMemo } from 'react';
import classNames from 'classnames';
import { createUseStyles } from '@Sage/hoi-poi-ui';
import SectionList from 'components/SectionList';
import { Header } from '../../../components';
import { ActionLink } from '../';

import styles from './styles.js';

const useStyles = createUseStyles(styles, 'Table');

const Table = ({
    className,
    title,
    description,
    actionText,
    actionOnClick,
    columnDefs,
    rowData,
    actions,
    loading,
    ...otherProps
}) => {
    const classes = useStyles();

    const headerProps = useMemo(
        () => ({
            title,
            description,
            className: classes.header,
        }),
        [classes.header, description, title],
    );

    const sectionListProps = useMemo(
        () => ({
            className: classes.sectionList,
            columnDefs,
            rowData,
            headerHeight: 40,
            rowHeight: 40,
            domLayout: 'autoHeight',
            actions,
            useLoaderPlaceholder: true,
            isLoading: loading,
            ...otherProps,
        }),
        [otherProps, classes.sectionList, columnDefs, rowData, actions, loading],
    );

    const actionLinkProps = useMemo(
        () => ({
            text: actionText,
            className: classes.action,
            isDisabled: loading,
            onClick: actionOnClick,
        }),
        [actionOnClick, actionText, classes.action, loading],
    );

    return (
        <div className={classNames(classes.root, { [classes.loading]: loading, className })}>
            <Header {...headerProps} />
            <SectionList {...sectionListProps} />
            <ActionLink {...actionLinkProps} />
        </div>
    );
};

export default memo(Table);
